import { useEffect, useState } from 'react'
import {
  fetchUserAttributes,
  fetchAuthSession,
  getCurrentUser,
} from 'aws-amplify/auth'
import type { AuthUser } from 'aws-amplify/auth'

export function useUserAttributes(): Record<string, string> | undefined {
  const [userAttr, setUserAttr] = useState<Record<string, string>>()

  useEffect(() => {
    fetchUserAttributes()
      .then((attributes) => setUserAttr(attributes as Record<string, string>))
      .catch((err) => {
        console.error('Error fetching user attributes:', err)
      })
  }, [])

  return userAttr
}

export function useAuthenticatedUser(): AuthUser | undefined {
  const [authUser, setAuthUser] = useState<AuthUser>()

  useEffect(() => {
    getCurrentUser()
      .then((user) => setAuthUser(user))
      .catch((err) => {
        console.error('Error fetching authenticated user:', err)
      })
  }, [])

  return authUser
}

// Helper hook to get user groups from token
export function useUserGroups(): string[] | undefined {
  const [groups, setGroups] = useState<string[]>()

  useEffect(() => {
    fetchAuthSession()
      .then((session) => {
        const groupz = session.tokens?.idToken?.payload['cognito:groups'] as
          | string[]
          | undefined
        setGroups(groupz || [])
      })
      .catch((err) => {
        console.error('Error fetching user groups:', err)
      })
  }, [])

  return groups
}
